import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getRequestInfo } from "../../actions/inquires";


import RangeSelect from "./RangeSelect";
import BooleanButton from "./BooleanButton";
import BooleanRadio from "./BooleanRadio";
import InputForm from "./InputForm";

class ClassRequestPurchase extends Component {
  constructor(props) {
    super(props);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleRangeChange = this.handleRangeChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  handleCheckChange(value, name) {
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  }
  handleRangeChange(index, label, name, leadLabel) {
    var value = { index: index, label: label , leadName: leadLabel};
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  }
  handleSelectChange(value, name) {
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  }
  handleInputChange(value, name) {
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  };
  render() {
    const horizontalLabels = [
      ["< 1 MOIS","<1"],
      ["3 MOIS","<3"],
      ["6 MOIS","<6"],
      ["> 6 MOIS",">6"]
    ];
    return (
      <div>
        <div className="pageFormTitle fontBold colorBlack">
          Voulez-vous essayer un véhicule ? *
        </div>
        <div className="pageFormSub">
          <BooleanRadio
            name="test"
            txt="Oui"
            state={this.props.inquires.achat.test}
            value="oui"
            onClick={this.handleCheckChange}
          />
          <BooleanRadio
            name="test"
            txt="Non"
            state={this.props.inquires.achat.test}
            value="non"
            onClick={this.handleCheckChange}
          />
        </div>
        {this.props.inquires.achat.test === "non" ? (
          <div>
            <div className="pageFormTitle fontBold colorBlack">
              Je souhaite réaliser mon rendez-vous :
            </div>
            <div className="pageFormSub">
              <BooleanRadio
                name="appointment"
                txt="Par téléphone"
                state={this.props.inquires.achat.appointment}
                value="telephone"
                onClick={this.handleCheckChange}
              />
              <BooleanRadio
                name="appointment"
                txt="Chez mon distributeur "
                state={this.props.inquires.achat.appointment}
                value="concession"
                onClick={this.handleCheckChange}
              />
            </div>
          </div>
        ) : null}
        <div className="pageFormTitle fontBold colorBlack">
          Idéalement vous souhaitez acheter un véhicule dans : *
        </div>
        <div className="pageFormSub">
          <RangeSelect
            name="purchaseTime"
            onChange={this.handleRangeChange}
            value={this.props.inquires.achat.purchaseTime.index}
            labels={horizontalLabels}
          />
        </div>
        <div className="pageFormTitle fontBold colorBlack">
          Seriez-vous intéressé par un mode de financement : *
        </div>
        <div className="pageFormSub">
          <BooleanRadio
            name="financing"
            txt="Oui"
            state={this.props.inquires.achat.financing}
            value="oui"
            onClick={this.handleCheckChange}
          />
          <BooleanRadio
            name="financing"
            txt="Non"
            state={this.props.inquires.achat.financing}
            value="non"
            onClick={this.handleCheckChange}
          />
        </div>
        <div className="pageFormClient">
          <div className="pageFormTitle fontBold colorBlack">
            Êtes-vous déjà client SEAT : *
          </div>
          <div className="pageFormSub">
            <BooleanRadio
              name="customerSeat"
              txt="Oui"
              state={this.props.inquires.achat.customerSeat}
              value="oui"
              onClick={this.handleCheckChange}
            />
            <BooleanRadio
              name="customerSeat"
              txt="Non"
              state={this.props.inquires.achat.customerSeat}
              value="non"
              onClick={this.handleCheckChange}
            />
          </div>
        </div>
        {this.props.inquires.achat.customerSeat === "oui" ? (
          <div className="pageFormPlate">
            <div className="pageFormTitle fontBold colorBlack">
              Votre véhicule :
            </div>
            <div className="pageFormSub">
              <InputForm
                name="plate"
                autoComplete="off"
                maxLength="8"
                placeholder="Numéro d’immatriculation"
                value={this.props.inquires.achat.plate}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getRequestInfo
    },
    dispatch
  );

export const RequestPurchase = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassRequestPurchase);



// WEBPACK FOOTER //
// ./src/containers/components/RequestPurchase.js